// Packages
import PropTypes from 'prop-types';

// Components
import Container from 'components/BTDUI/Container';
import ScreenTitle from 'components/ScreenTitle';
import Header from 'components/Header';
import Footer from 'components/Footer';

const TestSpecificationLayout = ({ children, title }) => {

	return (
		<div className='TestSpecificationLayout'>
			
			<Header/>

			<Container>

				<ScreenTitle title={title}/>

				{children}

			</Container>

			<Footer/>
        </div>
	)
}

TestSpecificationLayout.propTypes = {
	children: PropTypes.node,
	title: PropTypes.string
}

TestSpecificationLayout.defaultProps = {
	children: null,
	title: ''
}

export default TestSpecificationLayout;